import { defineComponent as v, useSlots as x, useCssModule as y, ref as E, watch as b, createElementBlock as a, openBlock as c, createElementVNode as s, withDirectives as k, createVNode as i, withKeys as h, normalizeClass as w, withModifiers as C, unref as l, renderSlot as _, Fragment as M, toDisplayString as S, vShow as $, withCtx as z } from "vue";
import { _ as B } from "./Expand.vue_vue_type_script_setup_true_lang-CiONJfAp.js";
import m from "./Icon.js";
import { _ as K } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = {
  class: "stash-accordion tw-rounded tw-border tw-border-ice-500 tw-bg-white",
  "data-test": "stash-accordion"
}, D = ["onKeypress"], I = { key: 0 }, N = { class: "tw-flex-1 tw-select-none tw-font-medium tw-leading-5 tw-text-ice-900" }, V = { class: "tw-mx-[18px] tw-h-px tw-bg-ice-200" }, j = {
  class: "stash-accordion__content tw-p-[18px]",
  "data-test": "stash-accordion|content"
}, F = /* @__PURE__ */ v({
  __name: "Accordion",
  props: {
    icon: { default: "circle-info" },
    title: { default: void 0 },
    isExpanded: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "open", "close"],
  setup(g, { emit: f }) {
    const t = g, d = x(), r = f, p = y();
    if (!t.title && !d.header)
      throw new Error("Either a title prop or header slot must be provided");
    const e = E(t.isExpanded);
    function u() {
      r("toggle", { isExpanded: e.value }), r(e.value ? "open" : "close");
    }
    const n = () => {
      e.value = !e.value, u();
    };
    return b(
      () => t.isExpanded,
      (o) => {
        e.value = o, u();
      }
    ), (o, J) => (c(), a("div", A, [
      s("div", {
        tabindex: "0",
        "data-test": "stash-accordion|toggle",
        class: w(["stash-accordion__toggle tw-flex tw-items-center", [l(p).toggle, e.value && l(p)["toggle--open"]]]),
        onClick: n,
        onKeypress: [
          h(n, ["enter"]),
          h(C(n, ["prevent"]), ["space"])
        ]
      }, [
        l(d).header ? (c(), a("div", I, [
          _(o.$slots, "header")
        ])) : (c(), a(M, { key: 1 }, [
          i(m, {
            class: "tw-text-blue-500",
            size: "dense",
            name: t.icon,
            "data-test": "stash-accordion|toggle-icon"
          }, null, 8, ["name"]),
          s("div", N, S(t.title), 1)
        ], 64)),
        i(m, {
          class: w(["tw-ml-auto tw-justify-center tw-text-ice-900 tw-transition-transform tw-duration-300", { "tw-rotate-180": e.value }]),
          size: "dense",
          name: "chevron-down",
          "data-test": "stash-accordion|toggle-chevron"
        }, null, 8, ["class"])
      ], 42, D),
      k(s("hr", V, null, 512), [
        [$, e.value]
      ]),
      i(B, { "is-expanded": e.value }, {
        default: z(() => [
          s("div", j, [
            _(o.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["is-expanded"])
    ]));
  }
}), q = "_toggle_1lu5k_2", G = {
  toggle: q
}, H = {
  $style: G
}, R = /* @__PURE__ */ K(F, [["__cssModules", H]]);
export {
  R as default
};
//# sourceMappingURL=Accordion.js.map
